import { render } from "./BudgetView.vue?vue&type=template&id=2c1d6d4c&ts=true"
import script from "./BudgetView.vue?vue&type=script&lang=ts"
export * from "./BudgetView.vue?vue&type=script&lang=ts"

import "./BudgetView.vue?vue&type=style&index=0&id=2c1d6d4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__